// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/style.scss
// module id = 1044
// module chunks = 0